import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Utilities from "../../dependencies/custom/react-utilities";
import Settings from "../../dependencies/custom/settings";
import { errorText } from "../../pages/academics/appraisal/appraisalUtils";

export default function useAppraisal() {
  const navigate = useNavigate();
  return useCallback(
    async (method, resource, data, params = {}) => {
      const [key, ...suffix] = resource.split("/");
      const endpoint =
        Settings.urls.academics[
          {
            cycles: "appraisalCycles",
            runs: "appraisalRuns",
            records: "appraisalRecords",
            weights: "appraisalWeights",
            bands: "appraisalBands",
            configs: "appraisalConfigs",
            notes: "appraisalNotes",
            criteria: "appraisalCriteria",
            fiveR: "appraisalFiveR",
          }[key]
        ];
      if (!endpoint) throw new Error("Unknown appraisal resource");
      const query = new URLSearchParams(
        Object.entries(params).filter(
          ([, value]) => value !== undefined && value !== null && value !== "",
        ),
      ).toString();
      const url = `${endpoint}${suffix.length ? `/${suffix.map(encodeURIComponent).join("/")}` : ""}${query ? `?${query}` : ""}`;
      const response = await Utilities.fetchWithAuth(
        method,
        url,
        data,
        navigate,
      );
      if (!response?.ok) {
        const serverMessage = response?.data
          ? errorText(response.data)
          : typeof response?.msg === "string"
            ? response.msg.trim()
            : "";
        const error = new Error(
          serverMessage ||
            `Request failed${response?.status ? ` (${response.status})` : ""}. Please try again.`,
        );
        error.status = response?.status;
        throw error;
      }
      return response.data;
    },
    [navigate],
  );
}
